import { useTranslation } from 'react-i18next'

import { FLOATING_ELEMENT_PLACEMENT } from '../../../constants/common'
import { QA_NAME_PROFILE_INFO_ITEM_VALUE } from '../../../constants/qa'
import { useContentOverflow } from '../../../hooks'
import { FloatingTooltip } from '../../Floating'
import Text from '../../Text'
import { EntityProfileHeaderInfoItemBase } from '../EntityProfileHeaderInfoItemBase'
import { EntityStatus } from '../EntityStatus'

import * as styles from './EntityProfileHeaderInfoItemStatus.module.css'

function EntityProfileHeaderInfoItemStatus({ ref, ...props }) {
  const { t } = useTranslation()

  const {
    id,
    noDataText = t('Profile.NoStatusTextKey'),
    statuses,
    tooltipPlacement = FLOATING_ELEMENT_PLACEMENT.top,
    value,
    ...restProps
  } = props

  const { overflow, setContentOverflowRef } = useContentOverflow({
    externalRef: ref,
  })

  return (
    <EntityProfileHeaderInfoItemBase
      {...restProps}
      contentExist={!!value}
      value={value}
    >
      {value?.text ? (
        <EntityStatus
          className={styles.status}
          id={id}
          statuses={statuses}
          textQaName={QA_NAME_PROFILE_INFO_ITEM_VALUE}
        />
      ) : (
        <FloatingTooltip
          content={noDataText}
          disabled={!overflow}
          placement={tooltipPlacement}
        >
          <Text
            disabled
            isSecondary
            qaName={QA_NAME_PROFILE_INFO_ITEM_VALUE}
            ref={setContentOverflowRef}
          >
            {noDataText}
          </Text>
        </FloatingTooltip>
      )}
    </EntityProfileHeaderInfoItemBase>
  )
}

export default EntityProfileHeaderInfoItemStatus
